// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"c143f260","161":"7364c293","281":"a1b3a9c7","525":"0e8fea3c","647":"f5880b89","782":"c0186fd5"}[chunkId] + ".chunk.js";
};